import type { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import { LOUNGE_PASSES_PAGE } from 'loyalty/constants/loyaltyRoutes'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyIsInfiniteAccountTier from 'loyalty/selectors/getLoyaltyIsInfiniteAccountTier'
import BodyText from 'LuxKit/Typography/BodyText'
import { INFINITE_FREE_LOUNGE_PASSES_PER_BOOKING } from 'loyalty/lib/infiniteFreeLoungePassLimit'

interface Props {
  layout: 'tile' | 'row'
  benefitLabel: ReactElement
}

function LandingPageLoyaltyLoungePass(props: Props) {
  const { layout, benefitLabel } = props
  const intl = useIntl()
  const isInfinite = useAppSelector(getLoyaltyIsInfiniteAccountTier)

  const heading = isInfinite
    ? intl.formatMessage({
        id: '1YMuXnuNqQzuTl-P50Iz',
        defaultMessage: 'Infinite airport lounge passes',
        description: 'Heading for the airport lounge pass benefit tile shown to Infinite tier members',
      })
    : intl.formatMessage({
        id: 'c9p-4SjsKWKqzrAh-aoA',
        defaultMessage: 'Free airport lounge passes',
        description: 'Heading for loyalty airport lounge pass benefit tile',
      })

  const infiniteSubtitle = (
    <BodyText variant="small">
      {intl.formatMessage({
        id: '_O2PDSh5ah71OcYDaKRP',
        defaultMessage: '{passCount} for every international trip',
        description: 'Subtitle on the Infinite member airport lounge pass benefit tile stating how many free passes are included on each international trip',
      }, { passCount: INFINITE_FREE_LOUNGE_PASSES_PER_BOOKING })}
    </BodyText>
  )

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="lounge_pass"
    heading={heading}
    subtitle={isInfinite ? infiniteSubtitle : benefitLabel}
    to={`/${LOUNGE_PASSES_PAGE}`}
  />
}

export default LandingPageLoyaltyLoungePass
